module.exports = __webpack_public_path__ + "img/approval.bc00aa9.svg";